import React, { useStat, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import "../../../../../../../css/workspace.css";
import { connect, useSelector, useDispatch} from "react-redux";
import {
    Button,
    Tabs,
  } from "antd";
import {
  ExportOutlined,
  FullscreenExitOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Walkthroughs from './walkthroughs';
import {
  uploadInstructionV2,
  updateSystemPrompt,
  updatePreProcessingInstructions,
  getWalkthroughs
} from "../../../../../../../redux/actions/collectionsV2";
import { notify } from "../../../../../../../components/Snack";

const GuardrailsSpace = ({ expandedBox, setExpandedBox }) => {

    const dispatch = useDispatch();
    const queryParams = useLocation().search;
    const uploadRef = useRef(null);
    const { TabPane } = Tabs;
    const expandBox = (boxId) => {
        setExpandedBox(boxId);
    };
    const collapseBox = () => {
        setExpandedBox(null);
    };

    const userDetails = useSelector(
        (state) => state?.organizationReducer?.currentOrganization
      );
    const viewOnly = userDetails?.role_id === "1" ? true : false;

    let additionalInstructionsValue = useSelector(
      (state) => state.collectionReducer.instructionData
    );
    let systemPromptValue = useSelector(
      (state) => state.collectionReducer.systemPrompt?.prompt
    );
    let preProcessingInstructionValue = useSelector(
      (state) => state.collectionReducer.preprocessingInstuctions
    );
    const userEmail = useSelector((state) => state.userReducer.user?.email);
    const collectionName =  new URLSearchParams(queryParams).get("name");

    const SystemPrompt = () => {
        const [value, setValue] = useState(systemPromptValue);
        const [isEditing, setIsEditing] = useState(false);

        const handleChange = (event) => {
          setIsEditing(true);
          setValue(event.target.value);
        };
    
        const handleSubmit = async () => {
          setIsEditing(false);
          const updateResponse = await updateSystemPrompt(collectionName, userEmail, value);
          dispatch(
            getWalkthroughs(new URLSearchParams(queryParams).get("name"))
          );
          updateResponse?.status == 200
            ? dispatch(notify("success", "System prompt updated"))
            : dispatch(notify("error", "System prompt updation failed. Please try again."));
        };
    
        const handleEdit = () => {
          setIsEditing(true);
        };
    
        return (
          <div className="text-area-block">
            {!viewOnly ?
            <div className="edit-right">
              <Button
                shape="circle"
                type="default"
                size="small"
                onClick={handleEdit}
                className={isEditing ? "active" : ""}
              >
                <EditOutlined />
              </Button>
            </div> : null}
            <div className="textarea-value">
            {!viewOnly && (isEditing || value?.length < 1) ? (
                <>
                  <textarea
                    value={value}
                    onChange={handleChange}
                    placeholder="Type something..."
                    style={{ resize: "none" }}
                  />
                  <div className="text-right">
                    <Button type="primary" size="small" onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div>
                </>
              ) : (
                <textarea
                value={value}
                disabled={true}
                style={{ resize: "none" }}
              />
              )}
            </div>
          </div>
        );
    };

    const PreProcessingInstructions = () => {
        const [value, setValue] = useState(preProcessingInstructionValue);
        const [isEditing, setIsEditing] = useState(false);
    
        const handleChange = (event) => {
          setIsEditing(true);
          setValue(event.target.value);
        };
    
        const handleSubmit = async () => {
          setIsEditing(false);
          const updateResponse = await updatePreProcessingInstructions(collectionName, userEmail, value);
          dispatch(
            getWalkthroughs(new URLSearchParams(queryParams).get("name"))
          );
          if (updateResponse?.status == 200 && updateResponse.message.includes('Success')) {
            dispatch(notify("success", "Preprocess instruction updated"))
          }
          else{
            dispatch(notify("error", updateResponse?.message));
            setValue(preProcessingInstructionValue)
          }
        }
    
        const handleEdit = () => {
          setIsEditing(true);
        };
    
        return (
          <div className="text-area-block">
             {!viewOnly ?
            <div className="edit-right">
              <Button
                shape="circle"
                type="default"
                size="small"
                onClick={handleEdit}
                className={isEditing ? "active" : ""}
              >
                <EditOutlined />
              </Button>
            </div> : null}
            <div className="textarea-value">
              {!viewOnly && (isEditing || value?.length < 1) ? (
                <>
                  <textarea
                    value={value}
                    onChange={handleChange}
                    placeholder="Type something..."
                    style={{ resize: "none" }}
                  />
                  <div className="text-right">
                    <Button type="primary" size="small" onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div>
                </>
              ) : (
                <textarea
                    value={value}
                    disabled={true}
                    style={{ resize: "none" }}
                  />
              )}
            </div>
          </div>
        );
    };

    const AdditionalInstructions = () => {
        const [value, setValue] = useState(additionalInstructionsValue);
        const [isEditing, setIsEditing] = useState(false);
    
        const handleChange = (event) => {
          setIsEditing(true);
          setValue(event.target.value);
        };
    
        const handleSubmit = async () => {
          setIsEditing(false);
          const updateResponse = await uploadInstructionV2(collectionName, value);
          dispatch(
            getWalkthroughs(new URLSearchParams(queryParams).get("name"))
          );
          updateResponse?.status == 200
          ? dispatch(notify("success", "User Instructions updated"))
          : dispatch(notify("error", "User Instructions updation failed. Please try again."));
        };
    
        const handleEdit = () => {
          setIsEditing(true);
        };
    
        return (
          <div className="text-area-block">
             {!viewOnly ?
            <div className="edit-right">
              <Button
                shape="circle"
                type="default"
                size="small"
                onClick={handleEdit}
                className={isEditing ? "active" : ""}
              >
                <EditOutlined />
              </Button>
            </div> : null}
            <div className="textarea-value">
            {!viewOnly && (isEditing || value?.length < 1) ? (
                <>
                  <textarea
                    value={value}
                    onChange={handleChange}
                    placeholder="Type something..."
                    style={{ resize: "none" }}
                  />
                  <div className="text-right">
                    <Button type="primary" size="small" onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div>
                </>
              ) : (
                <textarea
                value={value}
                disabled={true}
                style={{ resize: "none" }}
              />
              )}
            </div>
          </div>
        );
    };

    return(
        <>
        <div
          className={`flex-item-grid ${
            expandedBox === "box2" ? "expanded expanded-guardrails" : ""
          } ${expandedBox && expandedBox !== "box2" ? "hidden" : ""}`}
          id="box2"
        >
          <div className="fl-grid-block">
            <span className="block-name">Guardrails</span>
            <Tabs
              defaultActiveKey="1"
              type="card"
              tabBarExtraContent={
                expandedBox === "box2" ? (
                  <FullscreenExitOutlined
                    onClick={collapseBox}
                    className="tab-full-icon"
                  />
                ) : (
                  <ExportOutlined
                    onClick={() => expandBox("box2")}
                    className="tab-full-icon"
                  />
                )
              }
            >
              <TabPane tab="System Prompt" key="1">
                <SystemPrompt />
              </TabPane>
              <TabPane tab="Pre Processing Instructions" key="2">
                <PreProcessingInstructions />
              </TabPane>
              <TabPane tab="Additional Instructions" key="3">
                <AdditionalInstructions />
              </TabPane>
              {!viewOnly ?
              <TabPane tab="Walkthroughs" key="4">
                <Walkthroughs />
              </TabPane>
              : null}
            </Tabs>
          </div>
        </div>
        </>  
    )
}
export default GuardrailsSpace;